import { useQuery } from 'urql';
import { MemberUpdate } from '@/components/Member/MemberUpdate';
import { graphql } from '@/gql/graphql';

const GetAssignableRoles = graphql(/* GraphQL */ `
  query GetAssignableRoles {
    team_permission_role(
      distinct_on: [role]
      where: { role: { _neq: owner } }
      order_by: [{ role: asc }]
    ) {
      role
    }
  }
`);

export default function TeamPersonUpdateRoleInput({
  testID = 'TeamPersonUpdateRoleSelect',
}: {
  testID?: string;
}) {
  const [{ data, fetching }] = useQuery({ query: GetAssignableRoles });
  const roles = data?.team_permission_role || [];

  return (
    <MemberUpdate.RoleInput
      fetching={fetching}
      label="Role"
      roles={roles.map(({ role }) => role)}
      testID={testID}
    />
  );
}
